export default __webpack_public_path__ + "static/media/power_supply_equipment.8e6a40ff.svg";